import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { ReactComponent as ForwardRef$2 } from '../../../../assets/icons/CalenderSmall.svg.js';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/ErrorSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../../../assets/icons/WarningSmall.svg.js';
import Hint from '../../../Hint/Hint.js';
import 'date-fns/endOfWeek';
import 'date-fns/isSameDay';
import 'date-fns/isSameWeek';
import 'date-fns/isLastDayOfMonth';
import 'date-fns/isFirstDayOfMonth';
import 'date-fns/isWithinInterval';
import 'date-fns/startOfWeek';
import 'date-fns';
import { getLabelData } from '../../utils/getLabelData.js';
import { maskToTypedDate } from '../../utils/maskToTypedDate.js';
import 'date-fns/isValid';
import 'date-fns/getDay';
import { Root, PickerInput, Label } from './styled.js';

const DEFAULT_INPUT_PROPS = { 'data-testid': 'date-picker-input' };
const DatePickerInput = (_a, ref) => {
    var { inactive, error, size = 'small', disabled, value, labelFormat, placeholder, className, hint, hintDuration, inputRef, onClick, onBlur, onFocus, onChange, weekStartsOn, open, hasNoEnd, isRangePicker, isWeekPicker, customRange, allowSingleRange, width, noEndInputLabel, formatWithYear, ['data-testid']: testId, dateFormat, inputProps, locale, warning } = _a, rest = __rest(_a, ["inactive", "error", "size", "disabled", "value", "labelFormat", "placeholder", "className", "hint", "hintDuration", "inputRef", "onClick", "onBlur", "onFocus", "onChange", "weekStartsOn", "open", "hasNoEnd", "isRangePicker", "isWeekPicker", "customRange", "allowSingleRange", "width", "noEndInputLabel", "formatWithYear", 'data-testid', "dateFormat", "inputProps", "locale", "warning"]);
    const [showFormatted, setShowFormatted] = useState(true);
    const elementRef = useRef(null);
    useEffect(() => {
        if (inputRef) {
            inputRef.current = elementRef.current;
        }
    }, [inputRef]);
    const states = useMemo(() => {
        return {
            inactive: !open && inactive,
            error: error && !open && !disabled,
            disabled,
            open,
            warning: warning && !open,
        };
    }, [open, inactive, error, disabled, warning]);
    const onInputBlur = useCallback((e) => {
        setShowFormatted(true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur]);
    const onInputFocus = useCallback((e) => {
        setShowFormatted(!!isRangePicker);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, [isRangePicker, onFocus]);
    const onInputChange = useCallback((e) => {
        if (!isRangePicker) {
            e.target.value = maskToTypedDate(e.target.value, /\/{1}$/.test(value || ''));
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        }
    }, [onChange, value, isRangePicker]);
    const onOpen = useCallback((e) => {
        e.stopPropagation();
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    }, [disabled, onClick]);
    const onLabelFormatClick = useCallback((e) => {
        var _a;
        e.stopPropagation();
        if ((elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) && !disabled && !isRangePicker && !isWeekPicker) {
            (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setShowFormatted(false);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [disabled, isWeekPicker, isRangePicker, onClick]);
    const labelData = useMemo(() => {
        return Object.assign({ label: placeholder }, getLabelData(value, dateFormat, {
            labelFormat,
            isWeekPicker,
            weekStartsOn,
            customRange,
            hasNoEnd,
            noEndInputLabel,
            allowSingleRange,
            formatWithYear,
            isRangePicker,
            locale,
        }));
    }, [
        value,
        formatWithYear,
        placeholder,
        dateFormat,
        labelFormat,
        isWeekPicker,
        weekStartsOn,
        customRange,
        hasNoEnd,
        noEndInputLabel,
        allowSingleRange,
        isRangePicker,
        locale,
    ]);
    const Icon = states.error ? ForwardRef : states.warning ? ForwardRef$1 : ForwardRef$2;
    const iconTestId = states.error
        ? 'date-picker-icon-error'
        : states.warning
            ? 'date-picker-icon-warning'
            : 'date-picker-icon';
    return (jsx(Hint, Object.assign({ title: hint, duration: hintDuration }, { children: jsxs(Root, Object.assign({ onClick: onOpen, className: className, minWidth: labelData.sizes[size], width: width, "data-testid": testId }, states, { children: [jsx(Icon, { "data-testid": iconTestId }), jsx(PickerInput, Object.assign({}, rest, { ref: ref, size: size, value: value, open: open, onBlur: onInputBlur, onFocus: onInputFocus, onChange: onInputChange, inputRef: elementRef, placeholder: placeholder, inputProps: Object.assign(Object.assign({}, DEFAULT_INPUT_PROPS), inputProps) })), jsx(Label, Object.assign({}, states, { variant: value ? 'body1' : 'body4', hidden: !showFormatted, size: size, onClick: onLabelFormatClick, displayAsPlaceholder: !value }, { children: labelData.label }))] })) })));
};
var DatePickerInput$1 = React__default.forwardRef(DatePickerInput);

export { DatePickerInput$1 as default };
//# sourceMappingURL=DatePickerInput.js.map
